import { render, staticRenderFns } from "./ArticleDetailed.vue?vue&type=template&id=699f70e5&"
import script from "./ArticleDetailed.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports